<div class="cell small-12">
  <label class="full-width" for="formatter">Data Flag Enumeration Type:</label>
  <select id="flagEnumType" [(ngModel)]="options.selectedFlagEnum" (change)="selectedFlagEnumChangeHandler($event)">
    @for (flagEnum of flagEnumTypes; track flagEnum) {
      <option [value]="flagEnum">{{flagEnum}}</option>
    }
  </select>
</div>
<div class="cell small-12">
  <label class="full-width" for="formatter">Selected Enumeration Flag to Check:</label>
  <select id="selectedFlagEnumValue" [(ngModel)]="options.selectedFlagEnumValue" (change)="selectedFlagEnumValueChangeHandler($event)">
    @for (selectedFlagEnumValue of selectedflagEnumTypes; track selectedFlagEnumValue) {
      <option [value]="selectedFlagEnumValue">{{selectedFlagEnumValue}}</option>
    }
  </select>
</div>